import { HttpService } from './../../services/http.service';
import { Validacoes } from './../../services/valicacoes';
import { cliente } from './../../services/models';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
declare var $: any;
declare let fbq:Function;
@Component({
  selector: 'app-assinatura',
  templateUrl: './assinatura.component.html',
  styleUrls: ['./assinatura.component.scss'],
})
export class AssinaturaComponent implements OnInit {
  mes: any = [
    { id: 'MÊS' },
    { id: '01' },
    { id: '02' },
    { id: '03' },
    { id: '04' },
    { id: '05' },
    { id: '06' },
    { id: '07' },
    { id: '08' },
    { id: '09' },
    { id: '10' },
    { id: '11' },
    { id: '12' },
  ];

  ano = [
    { id: 'ANO' },
    { id: '2021' },
    { id: '2022' },
    { id: '2023' },
    { id: '2024' },
    { id: '2025' },
    { id: '2026' },
    { id: '2027' },
    { id: '2028' },
    { id: '2029' },
    { id: '2030' },
    { id: '2032' },
    { id: '2033' },
    { id: '2034' },
    { id: '2035' },
    { id: '2036' },
    { id: '2037' },
    { id: '2038' },
    { id: '2039' },
    { id: '2040' },
  ];
  assinaturaForm!: FormGroup;
  encryptSecretKey: string = 'stringdecripto';
  token!: string;
   _idExiste: any;

   valor:any;
  period: any;
  termos: any;

  cnpjUser:boolean;

  cpfecnpj:any;
boleto:any
formaPagamento:any;
  constructor(private formBuilder: FormBuilder, private http: HttpService, private rota:ActivatedRoute, private router:Router,private google:GoogleAnalyticsService) {
    this.cnpjUser =false;
    this.cpfecnpj = ''
  }

  ngOnInit(): void {

    this._idExiste = this.rota.snapshot.paramMap.get("id");



    if (!this._idExiste ) {
      this.router.navigate(['home']);
    }else{

      if (this._idExiste == "mensal" ||this._idExiste == "semestral" ||this._idExiste == "anual") {
        fbq('track', 'InitiateCheckout');
        if (this._idExiste == 'mensal') {
          this.valor = 79.90;
          this.period = "MONTHLY";
          this.boleto = false;
          this.scrollTop()
        }
        if (this._idExiste == 'semestral') {
          this.valor = 447.70;
          this.period = "SEMIANNUALLY"
          this.boleto = true;
          this.scrollTop()
        }
        if (this._idExiste == 'anual') {
          this.valor = 777.70;
          this.period = "YEARLY";
          this.boleto = true;
          this.scrollTop()
        }


      }else{
        this.router.navigate(['home']);
      }


    }

    this.assinaturaForm = this.formBuilder.group({
      nome: [''],
      email: [''],
      telCel: [''],
      cpf: [
        '',
        Validators.compose([Validators.required, Validacoes.ValidaCpf]),
      ],
      nascimento: [''],
      cep: [''],
      rua: [''],
      ruaNum: [''],
      bairro: [''],
      cidade: [''],
      estado: [''],
      complemento: [''],
      ccTitular: [''],
      ccNum: [''],
      ccMes: [''],
      ccAno: [''],
      ccCVD: [''],
      termos: [''],
      boleto: [''],
    });
  }

  whatsBlur(){
console.log('whats inserido');
fbq('track', 'Lead');

  }

  enviarDados(e: any) {
    console.log(e);
    let hoje = moment().format('YYYY-MM-DD');

    this.encryptData().then(() => {

      let sub : cliente;
      if (this.formaPagamento == 'Boleto') {

        sub = {
          token: this.token,
          name: e.nome,
          email: e.email,
          phone: e.telCel,
          mobilePhone: e.telCel,
          cpfCnpj: e.cpf,
          postalCode: e.cep,
          address: e.rua,
          addressNumber: e.ruaNum,
          complement: e.bairro,
          province: e.estado,
          notificationDisabled: false,
          observations: 'Cadastro via página de assinatura!',
          assinatura: {
            customer: '',
            billingType: 'BOLETO',
            nextDueDate: hoje,
            value: this.valor,
            cycle: this.period,
            description: `Assinatura ${this._idExiste} Yourder`,
          },
        }
      } else {
        sub = {
          token: this.token,
          name: e.nome,
          email: e.email,
          phone: e.telCel,
          mobilePhone: e.telCel,
          cpfCnpj: e.cpf,
          postalCode: e.cep,
          address: e.rua,
          addressNumber: e.ruaNum,
          complement: e.bairro,
          province: e.estado,
          notificationDisabled: false,
          observations: 'Cadastro via página de assinatura!',
          assinatura: {
            customer: '',
            billingType: 'CREDIT_CARD',
            nextDueDate: hoje,
            value: this.valor,
            cycle: this.period,
            description: `Assinatura ${this._idExiste} Yourder`,
            creditCard: {
              holderName: e.ccTitular,
              number: e.ccNum,
              expiryMonth: e.ccMes,
              expiryYear: e.ccAno,
              ccv: e.ccCVD,
            },
            creditCardHolderInfo: {
              name: e.ccTitular,
              email: e.email,
              cpfCnpj: e.cpf,
              postalCode: e.cep,
              addressNumber: e.ruaNum,
              addressComplement: e.rua,
              phone: e.telCel,
              mobilePhone: e.telCel,
            },
          },
        };
      }




      console.log(sub);

      this.http.criaAssinatura(sub).then(()=>{
        this.google.convertEventEmitter();
        this.assinaturaForm.reset()
      });
    });
  }

  onKey(){
console.log(this.cpfecnpj.length)

if (!this.cnpjUser) {
  if (this.cpfecnpj.length >= 10) {
    this.assinaturaForm.get('cpf')?.clearValidators();
  }
} else {
  if (this.cpfecnpj.length >= 13) {
    this.assinaturaForm.get('cpf')?.clearValidators();
  }
}
  }


  testeAss(){

    let hoje = moment().format('YYYY-MM-DD')

    let mesCC = '05';
    let cpf = '32999491875';
    let nome = '06felipesilvajones';
    let cep = '18520000';
    let tel = '15981216066';
    let email =  nome+'teste@teste.com';

    let sub : cliente;
    if (this.formaPagamento == 'Boleto') {

      sub = {
        address: 'asdasda',
        addressNumber: '45',
        assinatura: {
          billingType: 'UNDEFINED',
          creditCard: {
            ccv: '233',
            expiryMonth: mesCC,
            expiryYear: '2021',
            holderName: nome,
            number: '5162306219378829',
          },
          creditCardHolderInfo: {
            addressComplement: 'asdasda',
            addressNumber: '45',
            cpfCnpj: cpf,
            email: email,
            mobilePhone: tel,
            name: nome,
            phone: tel,
            postalCode: cep,
          },
          customer: '',
          cycle: 'MONTHLY',
          description: 'Assinatura Mensal Yourder',
          nextDueDate: '',
          value: 79.9,
        },
        complement: 'asdasda',
        cpfCnpj: cpf,
        email: email,
        mobilePhone:tel,
        name: nome,
        notificationDisabled: false,
        observations: 'Cadastro via página de assinatura!',
        phone: tel,
        postalCode: cep,
        province: 'São Paulo',
        token:
          'U2FsdGVkX18vzuAeVAGacqYgMsJSJ8RC0RZH27ojaOv+x02J1J38zjrL4VxuSnFk',
      };
    } else {

      sub = {
        address: 'asdasda',
        addressNumber: '45',
        assinatura: {
          billingType: 'CREDIT_CARD',
          creditCard: {
            ccv: '318',
            expiryMonth: mesCC,
            expiryYear: '2021',
            holderName: nome,
            number: '5162306219378829',
          },
          creditCardHolderInfo: {
            addressComplement: 'asdasda',
            addressNumber: '45',
            cpfCnpj: cpf,
            email: email,
            mobilePhone: tel,
            name: nome,
            phone: tel,
            postalCode: cep,
          },
          customer: '',
          cycle: 'MONTHLY',
          description: 'Assinatura Mensal Yourder',
          nextDueDate: hoje,
          value: 79.9,
        },
        complement: 'asdasda',
        cpfCnpj: cpf,
        email: email,
        mobilePhone:tel,
        name: nome,
        notificationDisabled: false,
        observations: 'Cadastro via página de assinatura!',
        phone: tel,
        postalCode: cep,
        province: 'São Paulo',
        token:
          'U2FsdGVkX18vzuAeVAGacqYgMsJSJ8RC0RZH27ojaOv+x02J1J38zjrL4VxuSnFk',
      };
    }



    console.log(sub);

    this.http.criaAssinatura(sub);
  }


  scrollTop() {
    const element = document.getElementById("top");
    console.log(element);
    if (element) {
      element.scrollIntoView({ block: 'start',  behavior: 'smooth' });
    }
  }

  modalTermos(){
 $('#termosModal').modal('show');
  }

  termosdeUso(e:any){

    console.log(e.srcElement.checked)

    this.termos = e.srcElement.checked
  }

  pagamentoTipo(e:any){

    if (e.srcElement.checked == true) {
      this.formaPagamento = 'Boleto'
      this.assinaturaForm.get('boleto')?.setValue(true)

      this.assinaturaForm.get('ccTitular')?.disable();
      this.assinaturaForm.get('ccNum')?.disable();
      this.assinaturaForm.get('ccMes')?.disable();
      this.assinaturaForm.get('ccAno')?.disable();
      this.assinaturaForm.get('ccCVD')?.disable();
    } else {
      this.formaPagamento = ''
      this.assinaturaForm.get('boleto')?.setValue(false);
      this.assinaturaForm.get('ccTitular')?.enable();
      this.assinaturaForm.get('ccNum')?.enable();
      this.assinaturaForm.get('ccMes')?.enable();
      this.assinaturaForm.get('ccAno')?.enable();
      this.assinaturaForm.get('ccCVD')?.enable();

    }
  }

  souCnpj(e:any){

    if (e.srcElement.checked == true) {
      this.cnpjUser = true
      this.cpfecnpj = ''
      this.assinaturaForm.get('cpf')?.setValue('')
    } else {
      this.cnpjUser = false
      this.cpfecnpj = ''
      this.assinaturaForm.get('cpf')?.setValue('')

    }
  }


  async encryptData() {
    let hoje = moment().format('DD/MM/YYYY');
    let data = `yourder${hoje}ok`;

    try {
      this.token = await CryptoJS.AES.encrypt(
        JSON.stringify(data),
        this.encryptSecretKey
      ).toString();
      console.log(this.token);
    } catch (e) {
      console.log(e);
    }
  }

  decryptData() {
    let decrip;
    try {
      const bytes = CryptoJS.AES.decrypt(this.token, this.encryptSecretKey);
      if (bytes.toString()) {
        decrip = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      console.log(decrip);
    } catch (e) {
      console.log(e);
    }
  }

  get cpf() {
    return this.assinaturaForm.get('cpf');
  }

  get ccMes() {
    //console.log(this.assinaturaForm.get('ccMes'));
    return this.assinaturaForm.get('ccMes');
  }
  get ccAno() {
    return this.assinaturaForm.get('ccAno');
  }
  get ccCVD() {
    return this.assinaturaForm.get('ccCVD');
  }
}
